/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    /*IQueryResultSettings,*/
    // @ts-ignore -- Unused import
    NullResult
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore -- Unused import
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
// @ts-ignore -- Unused import
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './DataServiceEntities.g';

// @ts-ignore
function getConfigParamQuery(id?: string): DataServiceQuery {
    const key = id ? { id: id } : null;
    return new DataServiceQuery('GetConfigParam', 'GetConfigParamEntity', DataServiceEntities.GetConfigParamEntityExtensionClass, key);
}

export function createGetConfigParamValuesInput(paramName: string): IDataServiceRequest {
    const query = getConfigParamQuery();
    return query.createDataServiceRequestForOperation(
        'GetConfigParamValues',
        true,
        DataServiceEntities.GetConfigParamEntityExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IGetConfigParamEntity' },
        { paramName: paramName }
    );
}

export function getConfigParamValuesAsync(context: IContext, paramName: string): AsyncResult<DataServiceEntities.IGetConfigParamEntity> {
    const request = createGetConfigParamValuesInput(paramName);
    return callActionOrExecute<DataServiceEntities.IGetConfigParamEntity>(request, context.callerContext);
}

// @ts-ignore
function validateTokenQuery(id?: string): DataServiceQuery {
    const key = id ? { id: id } : null;
    return new DataServiceQuery('ValidateToken', 'ValidateTokenEntity', DataServiceEntities.ValidateTokenEntityExtensionClass, key);
}

export function createValidateTokenInput(tokenCode: string, version: string, issuingParty: string): IDataServiceRequest {
    const query = validateTokenQuery();
    return query.createDataServiceRequestForOperation(
        'ValidateToken',
        true,
        DataServiceEntities.ValidateTokenEntityExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IValidateTokenEntity' },
        { tokenCode: tokenCode, version: version, issuingParty: issuingParty }
    );
}

export function validateTokenAsync(
    context: IContext,
    tokenCode: string,
    version: string,
    issuingParty: string
): AsyncResult<DataServiceEntities.IValidateTokenEntity> {
    const request = createValidateTokenInput(tokenCode, version, issuingParty);
    return callActionOrExecute<DataServiceEntities.IValidateTokenEntity>(request, context.callerContext);
}
